// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__39yLm","footer":"ModalUpdate_footer__1nseT"};